import { environment } from 'src/environments/environment';

export enum ProductSortType {
  PricesFromLowToHigh = 0,
  PricesFromHighToLow = 1
}

export function productSortTypeToString(sortType: ProductSortType): string {
  return sortType === ProductSortType.PricesFromLowToHigh ? 'Prices from low to high' : 'Prices from high to low';
}

export interface Product {
  id: number;
  stripe_id: string;
  test_stripe_id: string;
  name: string;
  description: string;
  additional_text: string;
  price: number;
  reduction: number;
  availabilityDate: Date;
}

export function GetImage(product: Product) {
  if (product.id == 2)
    return 'assets/Set/Set01_f.jpg'
  else if (product.id == 3)
    return 'assets/Set/Set02_f.jpg'
  else if (product.id == 4)
    return 'assets/Set/Set03_f.jpg'
  else if (product.id == 5)
    return 'assets/Set/Set04_f.jpg'
  else return '';
}

export function GetSquaredImage(product: Product) {
  if (product.id == 2)
    return 'assets/Set/Set01_squared_f.jpg'
  else if (product.id == 3)
    return 'assets/Set/Set02_squared_f.jpg'
  else if (product.id == 4)
    return 'assets/Set/Set03_squared_f.jpg'
  else if (product.id == 5)
    return 'assets/Set/Set04_squared_f.jpg'
  else return '';
}

export function GetStripeId(product: Product) {
  return environment.production ? product.stripe_id : product.test_stripe_id
}

export function lowToHigh(product1: Product, product2: Product) {
  return product1.price < product2.price ? -1 : product1.price > product2.price ? 1 : 0;
}

export function highToLow(product1: Product, product2: Product) {
  return -lowToHigh(product1, product2);
}

export const DefaultProduct: Product = {
  id: 0,
  stripe_id: 'price_xxxxxxxxxxxxxxxx',
  test_stripe_id: 'price_xxxxxxxxxxxxxxxx',
  name: '',
  description: '',
  additional_text: '',
  price: 0.00,
  reduction: 0,
  availabilityDate: new Date(2023, 0, 1)
}
